import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { Row, Col, Modal } from "antd";
import { InputItem, DatePickerItem } from "../../../components/forms/FormItems";
import DetailsHeader from "../../../components/forms/DetailsHeader";
import { MetaDataSelect } from "../../../components/forms/AutoCompleteFormItem";
import Surface from "../../../components/layouts/Surface";
import RadioButtonItem from "../../../components/forms/RadioButtonItem";
import ImageFormItem from "../../../components/forms/ImageFormItem";
import Spacer from "../../../components/layouts/Spacer";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import { FormattedMessage } from "react-intl";
import { activationConfirmMessage } from "../../../components/forms/formsFeedback";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { patientActivation } from "../patientDetailsSlice";

import moment from "moment";

const PersonalDetails = forwardRef((props, ref) => {
  const { smallSpace, hideActivator } = props;
  const activePatient = useSelector(
    (state) => state.patientDetails.activePatient
  );
  const intl = useIntl();
  const dispatch = useDispatch();
  const [modal, contextHolder] = Modal.useModal();
  const disabledDate = (current) => {
    const startdate = moment();
    return current && current > startdate;
  };
  const defaultPickerValue = moment();

  const onActivate = (checked) => {
    activationConfirmMessage(
      activePatient,
      intl,
      checked,
      activePatient.surename + " " + activePatient.first_name,
      "patients",
      onActivateConfirmed,
      modal
    );
  };

  const onActivateConfirmed = (record) => {
    dispatch(
      patientActivation({
        status_id: record.status_id === 1 || record.status_id === 3 ? 2 : 1,
      })
    );
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }} ref={ref}>
      {contextHolder}
      <Surface smallSpace={smallSpace}>
        <DetailsHeader
          resource={"patients"}
          action={"editor"}
          editTitle={<FormattedMessage id="app.patients.personalDetails" />}
          hasSwitch={!hideActivator}
          mode={"edit"}
          isActive={
            activePatient &&
            (activePatient.status_id === 1 || activePatient.status_id === 3)
          }
          onActivate={onActivate}
        />
        <Row>
          <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={8}>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <InputItem name="surename" category="patient" />
              </div>

              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <InputItem name="first_name" category="patient" />
              </div>
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <InputItem
                  name="local_id_number"
                  id={true}
                  category="patient"
                  required={activePatient.local_id_number}
                />
              </div>

              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <DatePickerItem
                  name="birthday"
                  category="patient"
                  disabledDate={disabledDate}
                  defaultPickerValue={defaultPickerValue}
                />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <MetaDataSelect
                  name="family_status_id"
                  category="patient"
                  metadataName="family_status"
                />
              </div>

              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <MetaDataSelect
                  metadataName="religions"
                  name="religion_id"
                  category="patient"
                  identfierId="id"
                />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <RadioButtonItem
                  required={true}
                  name="gender_id"
                  category="patient"
                  genders={true}
                  translated={true}
                />
              </div>

              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}></div>
            </ResponsiveItemsWrapper>
          </Col>

          <Col
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={{ span: 10, offset: 2 }}
            xxl={{ span: 8, offset: 2 }}
          >
            <ImageFormItem name="avatar_url" />
          </Col>
        </Row>
      </Surface>
    </div>
  );
});

PersonalDetails.propTypes = {
  addImage: PropTypes.func,
};

export default PersonalDetails;
